import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import RoleGuard from './components/guards/RoleGuard';
import { ROLES, DEPARTMENTS } from './auth/permissions';
import FinanceDashboard from './pages/FinanceDashboard';
import ComingSoon from './pages/ComingSoon';

import AssetsRoutes from './pages/assets/routes';
import ExpensesRoutes from './pages/expenses/routes';
import BudgetsRoutes from './pages/budgets/routes';
import InvoicesRoutes from './pages/invoices/routes';
import CustomersRoutes from './pages/customers/routes';
import SubscriptionsRoutes from './pages/subscriptions/routes';
import RevenueRoutes from './pages/revenue/routes';
import ProcurementRoutes from './pages/procurement/routes';
import PaymentsRoutes from './pages/payments/routes';
import ReimbursementsRoutes from './pages/reimbursements/routes';
import ApprovalsRoutes from './pages/approvals/routes';
import AdminRoutes from './pages/admin/routes';
import PayrollRoutes from './pages/payroll/routes';
import AdminHolidaysPage from './pages/admin/AdminHolidaysPage';
import HrLeaveManagementPage from '../components/Hr/HrLeaveManagementPage';
import AdminOnboardingDocsPage from './pages/admin/AdminOnboardingDocsPage';

const Authed = ({ children }) => (
  <RoleGuard roles={[ROLES.USER, ROLES.ADMIN, ROLES.SUPERADMIN]}>{children}</RoleGuard>
);

export default function FinanceRoutes() {
  return (
    <Routes>
      {/* When the user hits /finance exactly, redirect to dashboard */}
      <Route path="" element={<Navigate to="dashboard" replace />} />

      <Route
        path="dashboard"
        element={
          <Authed>
            <FinanceDashboard />
          </Authed>
        }
      />

      <Route path="assets/*" element={<Authed><AssetsRoutes /></Authed>} />
      <Route path="expenses/*" element={<Authed><ExpensesRoutes /></Authed>} />
      <Route path="reimbursements/*" element={<Authed><ReimbursementsRoutes /></Authed>} />
      <Route path="procurement/*" element={<Authed><ProcurementRoutes /></Authed>} />

      <Route
        path="budgets/*"
        element={
          <RoleGuard
            anyOf={[
              { roles: [ROLES.SUPERADMIN] },
              { roles: [ROLES.ADMIN], depts: [DEPARTMENTS.FINANCE] },
            ]}
          >
            <BudgetsRoutes />
          </RoleGuard>
        }
      />
      <Route
        path="invoices/*"
        element={
          <RoleGuard roles={[ROLES.ADMIN, ROLES.SUPERADMIN]}>
            <InvoicesRoutes />
          </RoleGuard>
        }
      />
      <Route
        path="customers/*"
        element={
          <RoleGuard roles={[ROLES.USER, ROLES.ADMIN, ROLES.SUPERADMIN]}>
            <CustomersRoutes />
          </RoleGuard>
        }
      />
      <Route
        path="subscriptions/*"
        element={
          <RoleGuard roles={[ROLES.ADMIN, ROLES.SUPERADMIN]}>
            <SubscriptionsRoutes />
          </RoleGuard>
        }
      />
      <Route
        path="payments/*"
        element={
          <RoleGuard
            anyOf={[
              { roles: [ROLES.SUPERADMIN] },
              { roles: [ROLES.ADMIN], depts: [DEPARTMENTS.FINANCE] },
            ]}
          >
            <PaymentsRoutes />
          </RoleGuard>
        }
      />
      <Route
        path="revenue/*"
        element={
          <RoleGuard roles={[ROLES.SUPERADMIN]}>
            <RevenueRoutes />
          </RoleGuard>
        }
      />

      <Route path="payroll/*" element={<Authed><PayrollRoutes /></Authed>} />
      <Route path="approvals/*" element={<Authed><ApprovalsRoutes /></Authed>} />

      {/* Note: In App.js we route /admin/* to FinanceRoutes as well.
          So if the base URL is /admin, the relative path "users" matches /admin/users.
          To keep /admin/* working, we can just use a splat route for admin here. */}
      <Route
        path="users/*"
        element={
          <RoleGuard roles={[ROLES.SUPERADMIN]}>
            <AdminRoutes />
          </RoleGuard>
        }
      />

      <Route
        path="holidays/*"
        element={
          <RoleGuard roles={[ROLES.SUPERADMIN]}>
            <AdminHolidaysPage />
          </RoleGuard>
        }
      />

      <Route
        path="leaves/*"
        element={
          <RoleGuard roles={[ROLES.SUPERADMIN]}>
            <HrLeaveManagementPage />
          </RoleGuard>
        }
      />

      <Route
        path="leave-manager/*"
        element={<Navigate to="../leaves" replace />}
      />

      <Route
        path="leave-management/*"
        element={<Navigate to="../leaves" replace />}
      />

      <Route
        path="onboarding-docs/*"
        element={
          <RoleGuard roles={[ROLES.SUPERADMIN]}>
            <AdminOnboardingDocsPage />
          </RoleGuard>
        }
      />

      <Route path="*" element={<ComingSoon title="Not Found" />} />
    </Routes>
  );
}
